// Import model
import { CreateEstimateRequest } from '../models/CreateEstimateRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateEstimateRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateEstimateRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateEstimateRequest instance
   */
  static deserialize(json: string): CreateEstimateRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateEstimateRequest instance
   */
  static fromObject(obj: any): CreateEstimateRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateEstimateRequest');
    }


    const instance: CreateEstimateRequest = {
      projectExternalId: obj['projectExternalId'] as string,
      roomSelectionIds: obj['roomSelectionIds'] ? (obj['roomSelectionIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string,
      description: obj['description'] as string | undefined,
      sessionKey: obj['sessionKey'] as string,
      summary: obj['summary'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateEstimateRequest instances
   */
  static deserializeArray(json: string): CreateEstimateRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateEstimateRequest instance to a JSON string
   */
  static serialize(instance: CreateEstimateRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateEstimateRequest instance to a plain object
   */
  static toObject(instance: CreateEstimateRequest): any {
    return {
      'projectExternalId': instance.projectExternalId,
      'roomSelectionIds': instance.roomSelectionIds?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'sessionKey': instance.sessionKey,
      'summary': instance.summary,
    };
  }

  /**
   * Serializes an array of CreateEstimateRequest instances to a JSON string
   */
  static serializeArray(instances: CreateEstimateRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
